import request from '@/utils/request'

const uploadPath = process.env.VUE_APP_BASE_API + 'file/uploadFile'
export { uploadPath }
export function uploadFileapi(params) {
    return request({
        url: '/file/uploadFile',
        method: 'get',
        params
    })
}
export function basebannerListapi(params) {
    return request({
        url: '/web/website/banner',
        method: 'get',
        params
    })
}
export function basebrandListapi(params) {
    return request({
        url: '/web/website/brand',
        method: 'get',
        params
    })
}
export function newsListbaseapi(params) {
    return request({
        url: '/web/website/news',
        method: 'get',
        params
    })
}
// 新闻详情
export function newsInfobaseapi(params) {
    return request({
        url: '/web/website/newsInfo',
        method: 'get',
        params
    })
}
export function bottomBarbaseapi(params) {
    return request({
        url: '/web/website/bottom',
        method: 'get',
        params
    })
}
export function goodsGroupbaseapi(params) {
    return request({
        url: '/web/website/group/goods',
        method: 'get',
        params
    })
}
export function groupbaseapi(params) {
    return request({
        url: '/web/website/group',
        method: 'get',
        params
    })
}
export function newGoodsbaseapi(params) {
    return request({
        url: '/web/website/newGoods',
        method: 'get',
        params
    })
}
export function companyinfobaseapi(params) {
    return request({
        url: '/web/website/company/info',
        method: 'get',
        params
    })
}
export function companyeventbaseapi(params) {
    return request({
        url: '/web/website/company/event',
        method: 'get',
        params
    })
}
export function getJobListemploymentapi(params) {
    return request({
        url: '/web/website/employment/getJobList',
        method: 'get',
        params
    })
}
export function getinitemploymentapi(params) {
    return request({
        url: '/web/website/employment/init',
        method: 'get',
        params
    })
}
// 通过职位id查看职位详情
export function jobinfoemploymentapi(jobId) {
    return request({
        url: `/web/website/employment/getDetailByJobId/${jobId}`,
        method: 'get'
    })
}
export function jobPageListapi(data) {
    return request({
        url: '/web/website/employment/jobPageList',
        method: 'post',
        data: data
    })
}

// 投递简历
export function sendResumeapi(data) {
    return request({
        url: '/web/website/employment/sendResume',
        method: 'post',
        data: data
    })
}

// 生成二维码
export function createQrCodewxapi(params) {
    return request({
        url: '/web/website/createQrCode',
        method: 'get',
        params
    })
}
